/**
 * Thank You Modal configuration
 */
export const modalConfig = {
  maxWidth: 330,
  redirectDelay: 1000, // milliseconds
  redirectPath: "/thank-you",
};

/**
 * Modal content text
 */
export const modalContent = {
  title: "Thank you!",
  message: "Thank you for showing your interest.",
  submessage: "We will get back to you soon.",
  closeButton: "Close",
};
